import styled from 'styled-components';
import { Button, Card } from 'antd';

export const FilterButton = styled(Button)`
  float: right;
  color: #d9d9d9;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
`;

export const FilterGroupButton = styled.div`
  text-align: end;
  .ant-btn {
    margin-right: 16px;
  }
`;

export const FilterComponentWrapper = styled.div`
  margin-top: 10px;
`;

export const FilterTitle = styled.p`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const FilterCardTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #31394d;
  font-weight: 500;
  float: left;
`;

export const FilterCardTitleWrapper = styled.div`
  display: block;
  .ant-btn {
    height: 25px;
    padding: 2px 0px;
    border: 0px;
    float: right;
  }
`;

export const TagSelect = styled.div`
  .ant-tag {
    display: table-caption;
    margin-bottom: 5px;
    padding: 2px 5px;
    border-radius: 4px;
    border: 1px solid #d0d7e3;
  }
`;

export const StyledCard = styled(Card)`
  .ant-table-cell {
    vertical-align: top;
    font-size: 12px !important;
  }
  .ant-card-head {
    padding: 0 16px;
  }
  .ant-card-body {
    padding: 16px;
  }
`;
